class tagsPicker {

    constructor(element) {

        if (typeof element == 'undefined') {
            return;
        }

        this.element = $(element);
        this.tags = [];
        this.container = $(this.element.data('tag-container'));
        this.input = $(this.element.data('input'));
        this.language = this.element.data('language');
      
        this.uniqid = ''+(new Date()).getTime();

        this.xhr;

        this.load();

        this.events();
    }

    events() {

        let self = this;

        this.element.on('keyup', function() {
            
            if ($(this).val().trim().length >= 2) {
                //do search
                self.search($(this).val());
            } else {
                $('#'+self.uniqid+'.tag-search-results').remove();
            }
        });

        this.element.on('keydown', function(e) {

            let code = e.keyCode || e.which;

            if(code != 13) {    
                return;

            } else {
              
                self.add({
                    "id": false,
                    "title": $(this).val().trim()
                });

                $(this).val('');

                e.preventDefault();
            }
        });

        $(document).on('click', this.element.data('tag-container')+' .tag > div:last-child', function() {

            let tagElement = $(this).closest('.tag');

            self.remove({
                "id": tagElement.data('id'),
                "title": tagElement.data('title')
            });
        });

        $(document).on('click', '#'+this.uniqid+'.tag-search-results ul li', function() {


            self.add({
                "id": $(this).data('id'),
                "title": $(this).data('title')
            });

            self.element.val('');

            $('#'+self.uniqid+'.tag-search-results').remove();
        });
    }

    load() {

        let self = this; 

        this.element.data('tags').forEach(function(item, index) {
            self.add(item);
        });

        this.checkNoTags();
        this.setData();
    }

    search(query) {

        $('#'+this.uniqid+'.tag-search-results').remove();

        let self = this,
            xhr = this.xhr;

        if (typeof xhr == 'object') {
            xhr.abort();
        }

        xhr = $.ajax({
            url: config.domain+'/'+config.app+'/functions/module.tagspicker.search.php',
            type: 'post',
            data: {
                "query": query.trim(),
                "language": this.language
            },
            dataType: 'json',
            success: function(response) {

                if (response.error == 0){

                    let list = [];
                    response.tags.forEach(function(item, index) {

                        if (!self.exists(item.title)) {
                            list.push(`<li data-id="`+item.id+`" data-title="`+item.title+`">`+item.title+`</li>`);
                        }
                    });

                    if (list.length > 0) {
                        self.element.parent().append($(`
                            <div class="tag-search-results" id="`+self.uniqid+`" style="top:`+(self.element.outerHeight() - 1)+`px">
                                <ul class="list-unstyled">
                                    `+list.join('')+`
                                </ul>
                            </div>
                            `)
                        );
                    }
                }
            }
        });
    }

    add(item) {

        if (item.title.length > 0 && !this.exists(item.title)) {

            this.container.append($(`
                <div class="tag" data-id="`+item.id+`" data-title="`+item.title+`">
                    <div class="row">
                        <div>`+item.title+`</div>
                        <div><i class="fa fa-times"></i></div>
                    </div>
                </div>`));
            
            
            this.tags.push({
                'id': item.id,
                'title': item.title
            });
        }

        this.checkNoTags();
        this.setData();
    }

    remove(item) {

        this.container.find('.tag[data-title="'+item.title+'"]').remove();

        if (this.exists(item.title)) {
            this.tags.splice(this.getIndexByTitle(item.title), 1);

        }

        this.checkNoTags();
        this.setData();
    }

    checkNoTags() {

        if (this.container.find('.tag').length == 0) {

            this.container.append($(`
                <div class="no-tags alert alert-warning">
                    There are no tags yet!
                </div>`));

        } else {
            this.container.find('.no-tags').remove();
        }
    }

    exists(title) {

        let b = false;

        title = title.trim();

        this.tags.forEach(function(item) {
            if (item.title == title) {
                b =true;
            }
        });

        return b;
    }

    getIndexByTitle(title) {

        let i = false;
        this.tags.forEach(function(item, index) {
            if (item.title == title) {
                i = index;
            }
        });

        return i;
    }

    setData() {
        this.input.val(JSON.stringify(this.tags));
    }
}